import styled from 'foundations-theming-specialty/utils';
import { useTranslation } from '../../hooks/useNavConfig';
import { EmptyFavoritesSubmenuSvg } from '../../components/Bookmarks/EmptyFavoritesSubmenuSvg';
import { Text } from 'breadcrumbs-ui/components/Text';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StyledEmptyShortcutsContent = styled.div.withConfig({
  displayName: "VerticalNavSecondaryMenuEmptyShortcutsContent__StyledEmptyShortcutsContent",
  componentId: "sc-76s4bj-0"
})(({
  theme
}) => {
  return {
    position: 'relative',
    margin: theme.space['200'],
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    color: theme.color['global-shell-text-nav-item-default']
  };
});
const StyledEmptyFavoritesSvg = styled(EmptyFavoritesSubmenuSvg)(() => ({
  width: '174px',
  height: '124px'
}));
const EmptyShortcutsMenuContent = () => {
  const {
    t
  } = useTranslation();
  return /*#__PURE__*/_jsxs(StyledEmptyShortcutsContent, {
    children: [/*#__PURE__*/_jsx(Text, {
      typography: "heading-50",
      textAlign: "center",
      marginBlockEnd: "300",
      children: t('nav.bookmarks2.emptyTitle')
    }), /*#__PURE__*/_jsx(StyledEmptyFavoritesSvg, {
      id: "empty-favorites",
      testId: "empty-shortcuts-illustration"
    }), /*#__PURE__*/_jsx(Text, {
      typography: "detail-200",
      textAlign: "center",
      marginBlockStart: "300",
      children: t('nav.bookmarks2.emptyBody')
    })]
  });
};
export default EmptyShortcutsMenuContent;